/**
 * Bright Ideas product cards
 * - Reads product specs from the description ("Label: Value" bullet lines) and the title
 * - Fills the feature tags on every card
 * - Add to basket: large appliances open a pop-up with the product's own service add-ons
 *   (rendered by snippets/service-addons-widget.liquid via ?view=bi-services) and add them
 *   to the cart in exactly the same format as assets/service-addons.js
 * - Compare: up to 4 products, kept in this browser, compared side by side
 * Also exposes window.BICards for assets/bi-collection.js (filters).
 */
(function () {
  if (window.BICards) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  var moneyFmt;
  try {
    moneyFmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: CURRENCY });
  } catch (e) {
    moneyFmt = { format: function (n) { return '£' + n.toFixed(2); } };
  }
  function fmt(cents) { return moneyFmt.format((cents || 0) / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  var YES = /^(yes|y|true)\b/i;

  /* ---------- Spec reading ---------- */
  function specMap(p) {
    if (p._m) return p._m;
    var m = { _b: [], _order: [] };
    (p.s || []).forEach(function (line) {
      var i = line.indexOf(':');
      if (i > 0 && i < 60) {
        var label = line.slice(0, i).trim();
        var k = norm(label);
        var val = line.slice(i + 1).trim();
        if (k && val && !(k in m)) {
          m[k] = val;
          m._order.push([label, k]);
        }
      } else {
        m._b.push(line);
      }
    });
    p._m = m;
    return m;
  }
  function get(p) {
    var m = specMap(p);
    for (var i = 1; i < arguments.length; i++) {
      var v = m[arguments[i]];
      if (v != null && v !== '') return v;
    }
    return null;
  }
  function yes(p) {
    for (var i = 1; i < arguments.length; i++) {
      var v = get(p, arguments[i]);
      if (v && YES.test(v)) return true;
    }
    return false;
  }
  function num(v) {
    if (v == null) return null;
    var m = String(v).replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }
  function hay(p) {
    if (p._hay == null) {
      p._hay = (p.t + ' | ' + specMap(p)._b.join(' | ')).toLowerCase();
    }
    return p._hay;
  }
  function meta(p) {
    if (p._meta == null) p._meta = ((p.ty || '') + ' ' + p.t + ' ' + (p.tg || []).join(' ')).toLowerCase();
    return p._meta;
  }
  function has(p, re) { return re.test(hay(p)); }

  /* ---------- Product family (decides tags + filters) ---------- */
  function family(p) {
    if (p._f) return p._f;
    var s = meta(p);
    var f = 'small';
    if (/washer[ -]?dryer/.test(s)) f = 'washerdryer';
    else if (/washing machine/.test(s)) f = 'washer';
    else if (/tumble|\bdryers?\b/.test(s) && !/hair|salad|clothes airer|airer/.test(s)) f = 'dryer';
    else if (/dishwasher/.test(s) && !/salt|tablet|rinse|cleaner/.test(s)) f = 'dishwasher';
    else if (/microwave/.test(s)) f = 'microwave';
    else if (/cooker hood|extractor|chimney hood|\bhoods?\b/.test(s)) f = 'hood';
    else if (/\bhobs?\b/.test(s)) f = 'hob';
    else if (/range cooker|\bcookers?\b/.test(s) && !/slow cooker|rice cooker|pressure cooker|multi ?cooker|soup/.test(s)) f = 'cooker';
    else if (/\bovens?\b|warming draw/.test(s) && !/mini oven|toaster oven/.test(s)) f = 'oven';
    else if (/fridge|freezer|refrigerat|wine cooler|wine cabinet|larder/.test(s) && !/filter|accessor|thermometer/.test(s)) f = 'fridge';
    else if (/television|\btvs?\b|\boled\b|\bqled\b/.test(s) && !/bracket|stand|remote|aerial|cable|mount/.test(s)) f = 'tv';
    else if (/vacuum|carpet cleaner|steam mop|floorcare|steam cleaner/.test(s) && !/bags?\b|filter|belt|accessor/.test(s)) f = 'floorcare';
    else if (/coffee|espresso|nespresso|tassimo|dolce gusto/.test(s) && !/descal|accessor|cup\b|mug/.test(s)) f = 'coffee';
    else if (/kettle/.test(s)) f = 'kettle';
    p._f = f;
    return f;
  }

  /* ---------- Attribute extractors ---------- */
  var COLOURS = [
    [/cream|ivory|almond/, 'Cream'],
    [/black stainless|black steel|black inox/, 'Black steel'],
    [/stainless|inox|brushed steel|\bsteel\b|chrome/, 'Stainless steel'],
    [/white/, 'White'],
    [/black/, 'Black'],
    [/silver/, 'Silver'],
    [/graphite|anthracite|titanium|grey|gray|slate/, 'Grey'],
    [/red|burgundy/, 'Red'],
    [/blue|navy|teal/, 'Blue'],
    [/green|sage|olive/, 'Green'],
    [/pink|rose/, 'Pink'],
    [/copper|gold|brass|champagne|bronze/, 'Copper / gold'],
    [/yellow/, 'Yellow'],
    [/orange/, 'Orange'],
    [/purple/, 'Purple']
  ];
  function colourOf(p) {
    var raw = get(p, 'colour of unit', 'dishwasher colour', 'colour', 'color', 'finish', 'unit colour', 'product colour');
    var src = raw ? raw.toLowerCase() : '';
    if (!src) {
      var parts = p.t.split(/ - | – /);
      src = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : p.t.toLowerCase();
    }
    for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i][0].test(src)) return COLOURS[i][1];
    return null;
  }
  function energyOf(p) {
    var v = get(p, 'energy rating', 'energy efficiency grade', 'energy grade', 'energy efficiency class', 'energy efficency grade', 'energy class');
    if (!v) {
      var m = p.t.match(/\b([a-g])\s?(?:energy|rated)\b/i);
      v = m ? m[1] : null;
    }
    if (!v) return null;
    var l = String(v).trim().toUpperCase().match(/^[A-G]/);
    return l ? l[0] : null;
  }
  function instOf(p) {
    var s = meta(p);
    if (/semi[- ]?integrated/.test(s)) return 'Semi-integrated';
    if (/fully[- ]?integrated|\bintegrated\b|built[- ]?in|built[- ]under/.test(s)) return 'Integrated';
    if (/free[- ]?standing/.test(s)) return 'Freestanding';
    return null;
  }
  function kgOf(p) {
    // The title wins when it states a size (what the customer reads), then the spec list
    var m = p.t.match(/(\d{1,2}(?:\.\d)?)\s?kg/i);
    var v = m ? parseFloat(m[1]) : num(get(p, 'capacity in kg', 'wash capacity', 'wash capacity kg', 'drum size', 'load capacity', 'drying capacity', 'drying capacity kg', 'capacity kg', 'washing capacity'));
    return v && v > 2 && v < 30 ? v : null;
  }
  function rpmOf(p) {
    var m = p.t.match(/(\d{3,4})\s?(?:rpm|spin)/i);
    var v = m ? parseFloat(m[1]) : num(get(p, 'washing machine spin speed', 'spin speed', 'max spin speed', 'washer dryer spin speed', 'maximum spin speed'));
    return v && v >= 400 && v <= 2000 ? v : null;
  }
  function widthCm(p) {
    var mm = num(get(p, 'width in mm', 'width mm', 'width'));
    var cm = null;
    if (mm && mm > 200 && mm < 2000) cm = Math.round(mm / 10);
    if (cm == null) {
      var m = p.t.match(/(\d{2,3})\s?cm\b/i);
      cm = m ? parseFloat(m[1]) : null;
    }
    if (!cm || cm < 20 || cm > 200) return null;
    // Snap to the standard appliance widths customers shop by
    var SIZES = [45, 50, 55, 60, 70, 80, 90, 100, 110, 120, 150];
    return SIZES.reduce(function (best, s) { return Math.abs(s - cm) < Math.abs(best - cm) ? s : best; }, SIZES[0]);
  }
  function screenIn(p) {
    var m = p.t.match(/(\d{2,3})(?:\s?(?:"|”|''|inch|in\b|-inch))/i);
    var v = m ? parseFloat(m[1]) : num(get(p, 'screen size', 'screen size inches'));
    return v && v >= 15 && v <= 120 ? v : null;
  }

  function pick(p, list) {
    for (var i = 0; i < list.length; i++) if (has(p, list[i][0])) return list[i][1];
    return null;
  }

  /* Each extractor returns a display value (string), an array (features) or null */
  var EX = {
    brand: { label: 'Brand', get: function (p) { return p.v || null; } },
    colour: { label: 'Colour', get: colourOf },
    energy: {
      label: 'Energy rating',
      get: function (p) { var e = energyOf(p); return e ? e + ' rated' : null; }
    },
    inst: { label: 'Installation', get: instOf, order: ['Freestanding', 'Integrated', 'Semi-integrated'] },
    stock: { label: 'Availability', get: function (p) { return p.a ? 'In stock' : null; } },
    price: { label: 'Price', get: function (p) { return priceBucket(p.p); } },
    drum: {
      label: 'Drum size',
      get: function (p) {
        var v = kgOf(p);
        if (v == null) return null;
        v = Math.round(v);
        if (v <= 7) return 'Up to 7kg';
        if (v >= 11) return '11kg and over';
        return v + 'kg';
      },
      order: ['Up to 7kg', '8kg', '9kg', '10kg', '11kg and over']
    },
    spin: {
      label: 'Spin speed',
      get: function (p) {
        var v = rpmOf(p);
        if (v == null) return null;
        if (v <= 1200) return 'Up to 1200rpm';
        if (v <= 1400) return '1400rpm';
        return '1500rpm and over';
      },
      order: ['Up to 1200rpm', '1400rpm', '1500rpm and over']
    },
    dryerType: {
      label: 'Dryer type',
      get: function (p) { return pick(p, [[/heat ?pump/, 'Heat pump'], [/condens/, 'Condenser'], [/vented|vent\b/, 'Vented']]); }
    },
    dwSize: {
      label: 'Size',
      get: function (p) {
        var t = (get(p, 'dishwasher type') || '').toLowerCase();
        if (/slim/.test(t) || has(p, /slimline|45 ?cm/)) return 'Slimline (45cm)';
        if (/table|compact|counter/.test(t) || has(p, /table ?top|compact|counter ?top/)) return 'Table top';
        var w = widthCm(p);
        if (w && w <= 50) return 'Slimline (45cm)';
        if (/full/.test(t) || (w && w >= 55)) return 'Full size (60cm)';
        return null;
      },
      order: ['Full size (60cm)', 'Slimline (45cm)', 'Table top']
    },
    places: {
      label: 'Place settings',
      get: function (p) {
        var v = num(get(p, 'place settings', 'number of place settings'));
        if (v == null) { var m = p.t.match(/(\d{1,2})\s?place/i); v = m ? parseFloat(m[1]) : null; }
        if (!v || v > 20) return null;
        if (v <= 9) return 'Up to 9';
        if (v >= 15) return '15 or more';
        return String(v);
      },
      order: ['Up to 9', '10', '11', '12', '13', '14', '15 or more']
    },
    fridgeType: {
      label: 'Type',
      get: function (p) {
        return pick(p, [
          [/american|side ?by ?side|french door|multi ?door|four door|4 door/, 'American style'],
          [/wine/, 'Wine cooler'],
          [/chest/, 'Chest freezer'],
          [/under ?counter|undercounter|table ?top/, 'Under counter'],
          [/larder/, 'Larder fridge'],
          [/fridge ?freezer/, 'Fridge freezer'],
          [/freezer/, 'Freezer'],
          [/fridge|refrigerator/, 'Fridge']
        ]);
      }
    },
    split: {
      label: 'Fridge / freezer split',
      get: function (p) {
        var v = get(p, 'fridge freezer split', 'split');
        var m = (v || p.t).match(/(\d{2})\s?\/\s?(\d{2})/);
        return m ? m[1] + '/' + m[2] : null;
      }
    },
    fuel: {
      label: 'Fuel type',
      get: function (p) {
        return pick(p, [[/dual fuel|duel fuel/, 'Dual fuel'], [/induction/, 'Induction'], [/\bgas\b/, 'Gas'], [/ceramic/, 'Ceramic'], [/electric/, 'Electric']]);
      }
    },
    hobType: {
      label: 'Hob type',
      get: function (p) {
        return pick(p, [[/induction/, 'Induction'], [/\bgas\b/, 'Gas'], [/ceramic/, 'Ceramic'], [/domino/, 'Domino'], [/electric|solid plate/, 'Electric']]);
      }
    },
    width: { label: 'Width', get: function (p) { var w = widthCm(p); return w ? w + 'cm' : null; }, numeric: true },
    cavity: {
      label: 'Ovens',
      get: function (p) { return pick(p, [[/double oven|twin cavity|double cavity|two cavit/, 'Double oven'], [/single oven|single cavity/, 'Single oven']]); }
    },
    ovenType: {
      label: 'Oven type',
      get: function (p) {
        return pick(p, [[/warming draw/, 'Warming drawer'], [/built[- ]under/, 'Built-under double'], [/double/, 'Double oven'], [/compact|combi(nation)? microwave|steam oven/, 'Compact'], [/single/, 'Single oven']]);
      }
    },
    zones: {
      label: 'Cooking zones',
      get: function (p) {
        var v = num(get(p, 'number of zones', 'cooking zones', 'number of cooking zones', 'number of burners', 'burners'));
        if (v == null) { var m = p.t.match(/(\d)\s?(?:zone|burner)/i); v = m ? parseFloat(m[1]) : null; }
        return v && v < 10 ? v + ' zones' : null;
      },
      numeric: true
    },
    hoodType: {
      label: 'Hood style',
      get: function (p) {
        return pick(p, [[/island/, 'Island'], [/downdraft/, 'Downdraft'], [/canopy|integrated|built[- ]in/, 'Integrated / canopy'], [/telescopic/, 'Telescopic'], [/angled|visor|inclined/, 'Angled'], [/chimney/, 'Chimney'], [/visor|standard/, 'Standard']]);
      }
    },
    mwType: {
      label: 'Microwave type',
      get: function (p) { return pick(p, [[/combination|combi\b/, 'Combination'], [/grill/, 'With grill'], [/solo|standard|manual|digital/, 'Solo']]); }
    },
    mwCap: {
      label: 'Capacity',
      get: function (p) {
        var v = num(get(p, 'capacity', 'total capacity', 'oven capacity', 'capacity litres'));
        if (v == null) { var m = p.t.match(/(\d{2})\s?(?:l\b|ltr|litre)/i); v = m ? parseFloat(m[1]) : null; }
        if (!v || v > 60) return null;
        if (v < 20) return 'Under 20 litres';
        if (v <= 25) return '20 to 25 litres';
        if (v <= 30) return '26 to 30 litres';
        return 'Over 30 litres';
      },
      order: ['Under 20 litres', '20 to 25 litres', '26 to 30 litres', 'Over 30 litres']
    },
    power: {
      label: 'Power',
      get: function (p) {
        var v = num(get(p, 'microwave power', 'power', 'output power', 'wattage'));
        if (v == null) { var m = p.t.match(/(\d{3,4})\s?w\b/i); v = m ? parseFloat(m[1]) : null; }
        if (!v || v < 300 || v > 3000) return null;
        if (v < 800) return 'Under 800W';
        if (v <= 900) return '800 to 900W';
        return 'Over 900W';
      },
      order: ['Under 800W', '800 to 900W', 'Over 900W']
    },
    screen: {
      label: 'Screen size',
      get: function (p) {
        var v = screenIn(p);
        if (!v) return null;
        if (v <= 32) return 'Up to 32"';
        if (v <= 43) return '40" to 43"';
        if (v <= 55) return '48" to 55"';
        if (v <= 65) return '58" to 65"';
        return '70" and over';
      },
      order: ['Up to 32"', '40" to 43"', '48" to 55"', '58" to 65"', '70" and over']
    },
    res: {
      label: 'Resolution',
      get: function (p) { return pick(p, [[/\b8k\b/, '8K'], [/\b4k\b|ultra hd|\buhd\b/, '4K Ultra HD'], [/full hd|1080/, 'Full HD'], [/\bhd ready\b|\bhd\b|720/, 'HD']]); },
      order: ['8K', '4K Ultra HD', 'Full HD', 'HD']
    },
    vacType: {
      label: 'Type',
      get: function (p) {
        return pick(p, [[/robot/, 'Robot'], [/carpet|wet ?(and|&) ?dry|wet\b/, 'Carpet / wet & dry'], [/steam/, 'Steam'], [/handheld|hand held/, 'Handheld'], [/cordless|stick|2[- ]in[- ]1/, 'Cordless'], [/upright/, 'Upright'], [/cylinder/, 'Cylinder']]);
      }
    },
    bag: { label: 'Bag type', get: function (p) { return pick(p, [[/bagless/, 'Bagless'], [/bagged|\bbag\b/, 'Bagged']]); } },
    coffeeType: {
      label: 'Machine type',
      get: function (p) {
        return pick(p, [[/bean ?to ?cup/, 'Bean to cup'], [/pod|capsule|nespresso|dolce gusto|tassimo|vertuo/, 'Pod & capsule'], [/grinder/, 'Grinder'], [/filter|drip/, 'Filter'], [/espresso|pump|barista/, 'Espresso']]);
      }
    },
    kCap: {
      label: 'Capacity',
      get: function (p) {
        var v = num(get(p, 'capacity', 'water capacity', 'capacity litres'));
        if (v == null) { var m = p.t.match(/(\d(?:\.\d{1,2})?)\s?(?:l\b|ltr|litre)/i); v = m ? parseFloat(m[1]) : null; }
        if (!v || v > 5) return null;
        if (v < 1.5) return 'Under 1.5 litres';
        if (v < 1.7) return '1.5 to 1.6 litres';
        if (v <= 1.7) return '1.7 litres';
        return 'Over 1.7 litres';
      },
      order: ['Under 1.5 litres', '1.5 to 1.6 litres', '1.7 litres', 'Over 1.7 litres']
    },
    feat: { label: 'Features', get: function (p) { return featuresOf(p); }, multi: true }
  };

  var FEATS = {
    washer: [
      ['Quick wash', function (p) { return yes(p, 'quick wash') || has(p, /quick wash|rapid/); }],
      ['Add wash / reload', function (p) { return yes(p, 'add wash') || has(p, /add ?wash|reload/); }],
      ['Smart / app control', function (p) { return yes(p, 'smart washing machine') || has(p, /wi-?fi|home connect|smartthings|thinq|\bsmart\b/); }],
      ['Steam', function (p) { return has(p, /steam/); }],
      ['Auto dosing', function (p) { return yes(p, 'auto dosing') || has(p, /i-?dos|auto ?dos/); }],
      ['Anti-flood', function (p) { return yes(p, 'anti flood device', 'anti flood'); }]
    ],
    washerdryer: [
      ['Quick wash', function (p) { return yes(p, 'quick wash') || has(p, /quick wash/); }],
      ['Smart / app control', function (p) { return has(p, /wi-?fi|home connect|smartthings|thinq|\bsmart\b/) || yes(p, 'smart washer dryer'); }],
      ['Steam', function (p) { return has(p, /steam/); }]
    ],
    dryer: [
      ['Sensor drying', function (p) { return has(p, /sensor/) || yes(p, 'sensor dry', 'sensor drying'); }],
      ['Smart / app control', function (p) { return has(p, /wi-?fi|home connect|smartthings|thinq|\bsmart\b/); }],
      ['Reverse tumble', function (p) { return has(p, /reverse/); }]
    ],
    dishwasher: [
      ['Quick wash', function (p) { return yes(p, 'quick wash'); }],
      ['Half load', function (p) { return yes(p, 'half load'); }],
      ['Cutlery drawer', function (p) { return /drawer|tray|third/i.test(get(p, 'cutlery system') || '') || has(p, /cutlery (drawer|tray)/); }],
      ['Smart / app control', function (p) { return yes(p, 'smart dishwasher') || has(p, /wi-?fi|home connect|\bsmart\b/); }],
      ['Anti-flood', function (p) { return yes(p, 'anti flood device'); }]
    ],
    fridge: [
      ['Frost free', function (p) { return yes(p, 'frost free') || has(p, /no ?frost|frost[- ]free/); }],
      ['Water dispenser', function (p) { return yes(p, 'water dispenser'); }],
      ['Ice maker', function (p) { return yes(p, 'ice dispenser', 'ice maker'); }],
      ['Smart / app control', function (p) { return yes(p, 'smart fridge freezer', 'smart fridge', 'smart freezer'); }],
      ['Reversible door', function (p) { return yes(p, 'reversible doors', 'reversible door'); }]
    ],
    cooker: [
      ['Self-cleaning', function (p) { return has(p, /pyrolytic|self[- ]clean|catalytic/); }],
      ['Fan oven', function (p) { return has(p, /fan oven|fanned|multifunction|multi-function/); }],
      ['Grill', function (p) { return has(p, /grill/); }]
    ],
    oven: [
      ['Pyrolytic cleaning', function (p) { return has(p, /pyrolytic/); }],
      ['Steam', function (p) { return has(p, /steam/); }],
      ['Air fry', function (p) { return has(p, /air ?fry/); }],
      ['Slide & hide door', function (p) { return has(p, /slide ?(&|and) ?hide/); }],
      ['Smart / app control', function (p) { return has(p, /wi-?fi|home connect|\bsmart\b/); }]
    ],
    tv: [
      ['Smart TV', function (p) { return has(p, /\bsmart\b|android|google tv|webos|tizen/); }],
      ['Freeview Play', function (p) { return has(p, /freeview play/); }],
      ['HDR', function (p) { return has(p, /\bhdr|dolby vision/); }]
    ],
    floorcare: [
      ['Pet hair tools', function (p) { return has(p, /\bpet\b|animal/); }],
      ['Cordless', function (p) { return has(p, /cordless/); }]
    ]
  };
  function featuresOf(p) {
    var list = FEATS[family(p)] || [];
    var out = [];
    list.forEach(function (f) { if (f[1](p)) out.push(f[0]); });
    return out;
  }

  /* Filter groups per family (common groups added after) */
  var GROUPS = {
    washer: ['inst', 'drum', 'spin', 'energy', 'feat'],
    washerdryer: ['inst', 'drum', 'spin', 'energy', 'feat'],
    dryer: ['dryerType', 'inst', 'drum', 'energy', 'feat'],
    dishwasher: ['dwSize', 'inst', 'places', 'energy', 'feat'],
    fridge: ['fridgeType', 'inst', 'split', 'feat', 'energy'],
    cooker: ['fuel', 'width', 'cavity', 'feat', 'energy'],
    oven: ['ovenType', 'fuel', 'feat', 'energy'],
    hob: ['hobType', 'width', 'zones'],
    hood: ['hoodType', 'width'],
    microwave: ['mwType', 'inst', 'mwCap', 'power'],
    tv: ['screen', 'res', 'feat'],
    floorcare: ['vacType', 'bag', 'feat'],
    coffee: ['coffeeType'],
    kettle: ['kCap'],
    small: []
  };
  var COMMON = ['brand', 'price', 'colour', 'stock'];

  /* Price buckets adapt to the price range of the page */
  var PRICE_BUCKETS = [[0, 300], [300, 500], [500, 750], [750, 1000], [1000, 1500], [1500, Infinity]];
  function setPriceBuckets(products) {
    var prices = products.map(function (p) { return p.p; }).filter(function (x) { return x > 0; }).sort(function (a, b) { return a - b; });
    if (!prices.length) return;
    var med = prices[Math.floor(prices.length / 2)] / 100;
    var steps;
    if (med < 40) steps = [0, 15, 25, 40, 60, 100];
    else if (med < 120) steps = [0, 25, 50, 100, 150, 250];
    else if (med < 400) steps = [0, 100, 200, 300, 400, 600];
    else if (med < 900) steps = [0, 300, 500, 750, 1000, 1500];
    else steps = [0, 750, 1000, 1500, 2000, 3000];
    PRICE_BUCKETS = steps.map(function (s, i) { return [s, i + 1 < steps.length ? steps[i + 1] : Infinity]; });
  }
  function pounds(n) { return '£' + n.toLocaleString('en-GB'); }
  function bucketLabel(b) {
    if (b[0] === 0) return 'Under ' + pounds(b[1]);
    if (b[1] === Infinity) return pounds(b[0]) + ' and over';
    return pounds(b[0]) + ' to ' + pounds(b[1]);
  }
  function priceBucket(cents) {
    if (!cents || cents <= 0) return null;
    var v = cents / 100;
    for (var i = 0; i < PRICE_BUCKETS.length; i++) {
      if (v >= PRICE_BUCKETS[i][0] && v < PRICE_BUCKETS[i][1]) return bucketLabel(PRICE_BUCKETS[i]);
    }
    return null;
  }
  function priceOrder() { return PRICE_BUCKETS.map(bucketLabel); }

  function attr(p, key) {
    p._a = p._a || {};
    if (!(key in p._a)) {
      var ex = EX[key];
      p._a[key] = ex ? ex.get(p) : null;
    }
    return p._a[key];
  }
  function values(p, key) {
    var v = attr(p, key);
    if (v == null) return [];
    return Array.isArray(v) ? v : [v];
  }

  /* ---------- Feature tags on cards (max 3) ---------- */
  function chips(p) {
    var f = family(p);
    var out = [];
    function add(x) { if (x && out.length < 3 && out.indexOf(x) === -1) out.push(x); }
    var kg = kgOf(p), rpm = rpmOf(p), e = energyOf(p), inst = instOf(p), w = widthCm(p);
    var energyChip = e ? 'Energy ' + e : null;
    switch (f) {
      case 'washer':
      case 'washerdryer':
        if (inst === 'Integrated') add('Integrated');
        add(kg ? (kg % 1 ? kg : Math.round(kg)) + 'kg' : null);
        add(rpm ? rpm + 'rpm' : null);
        add(energyChip);
        break;
      case 'dryer':
        add(attr(p, 'dryerType'));
        add(kg ? Math.round(kg) + 'kg' : null);
        add(energyChip);
        break;
      case 'dishwasher':
        var size = attr(p, 'dwSize');
        add(size ? size.replace(/ \(.*\)/, '') : null);
        var pl = num(get(p, 'place settings'));
        add(pl ? pl + ' place settings' : null);
        if (inst === 'Integrated') add('Integrated');
        add(energyChip);
        break;
      case 'fridge':
        if (inst === 'Integrated') add('Integrated');
        add(attr(p, 'split') ? attr(p, 'split') + ' split' : null);
        add(values(p, 'feat').indexOf('Frost free') > -1 ? 'Frost free' : null);
        add(energyChip);
        break;
      case 'cooker':
      case 'oven':
      case 'hob':
        add(attr(p, f === 'hob' ? 'hobType' : 'fuel'));
        add(w ? w + 'cm' : null);
        add(f === 'oven' ? attr(p, 'ovenType') : f === 'cooker' ? attr(p, 'cavity') : attr(p, 'zones'));
        add(energyChip);
        break;
      case 'hood':
        add(attr(p, 'hoodType'));
        add(w ? w + 'cm' : null);
        add(colourOf(p));
        break;
      case 'microwave':
        add(attr(p, 'mwType'));
        var cap = p.t.match(/(\d{2})\s?(?:l\b|ltr|litre)/i);
        add(cap ? cap[1] + ' litres' : null);
        var pw = p.t.match(/(\d{3,4})\s?w\b/i);
        add(pw ? pw[1] + 'W' : null);
        break;
      case 'tv':
        var sc = screenIn(p);
        add(sc ? sc + '"' : null);
        add(attr(p, 'res'));
        add(values(p, 'feat').indexOf('Smart TV') > -1 ? 'Smart TV' : null);
        break;
      case 'floorcare':
        add(attr(p, 'vacType'));
        add(attr(p, 'bag'));
        add(values(p, 'feat').indexOf('Pet hair tools') > -1 ? 'Pet tools' : null);
        break;
      case 'coffee':
        add(attr(p, 'coffeeType'));
        add(colourOf(p));
        break;
      case 'kettle':
        var kc = p.t.match(/(\d(?:\.\d{1,2})?)\s?(?:l\b|ltr|litre)/i);
        add(kc ? kc[1] + ' litres' : null);
        add(colourOf(p));
        break;
      default:
        add(colourOf(p));
    }
    return out;
  }

  /* ---------- Card markup (keep in step with snippets/bi-product-card.liquid) ---------- */
  var TRUCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 6h11v10H2zM13 9h4l3 3v4h-7"></path><circle cx="6" cy="17.5" r="1.8"></circle><circle cx="16.5" cy="17.5" r="1.8"></circle></svg>';
  function isLarge(p) { return (p.tg || []).some(function (t) { return /^large appliances$/i.test(t); }); }
  function cardHTML(p, lazy) {
    var t = esc(p.t);
    var price = p.p > 0
      ? '<span class="bi-card__price">' + fmt(p.p) + '</span>' + (p.c > p.p ? '<span class="bi-card__was">Was ' + fmt(p.c) + '</span>' : '')
      : '<span class="bi-card__call">Call for price</span>';
    var action;
    if (!(p.p > 0)) action = '<a class="bi-btn bi-btn--primary" href="/pages/enquiry-page">Enquire<span class="visually-hidden"> about ' + t + '</span></a>';
    else if (!p.a) action = '<button type="button" class="bi-btn bi-btn--primary" disabled>Out of stock</button>';
    else if (p.vc > 1) action = '<a class="bi-btn bi-btn--primary" href="' + esc(p.u) + '">Choose options<span class="visually-hidden"> for ' + t + '</span></a>';
    else action = '<button type="button" class="bi-btn bi-btn--primary" data-bi-add>Add to basket<span class="visually-hidden"> – ' + t + '</span></button>';
    var chipHTML = chips(p).map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('');
    return (
      '<article class="bi-card" data-handle="' + esc(p.h) + '" data-bi-ready="1">' +
      '<a class="bi-card__media" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="" width="600" height="600"' + (lazy === false ? '' : ' loading="lazy"') + '>' : '') +
      '</a><div class="bi-card__body">' +
      '<span class="bi-card__brand">' + esc(p.v) + '</span>' +
      '<h3 class="bi-card__title"><a href="' + esc(p.u) + '">' + t + '</a></h3>' +
      '<ul class="bi-card__chips" role="list" aria-label="Key features">' + chipHTML + '</ul>' +
      '<div class="bi-card__price-row">' + price + '</div>' +
      (isLarge(p) ? '<p class="bi-card__fit">' + TRUCK + 'Delivery, fitting &amp; removal available</p>' : '') +
      '<div class="bi-card__actions">' + action +
      '<label class="bi-compare"><input type="checkbox" data-bi-compare' + (inCompare(p.h) ? ' checked' : '') + '>Compare<span class="visually-hidden"> ' + t + '</span></label>' +
      '</div></div></article>'
    );
  }

  /* ---------- Registry + card init ---------- */
  var REG = {};
  function register(p) { if (p && p.h) REG[p.h] = p; return p; }
  function productFor(el) {
    var card = el.closest('[data-handle]');
    return card ? REG[card.getAttribute('data-handle')] : null;
  }
  function initCards(root) {
    (root || document).querySelectorAll('.bi-card:not([data-bi-ready])').forEach(function (card) {
      card.setAttribute('data-bi-ready', '1');
      var raw = card.getAttribute('data-product');
      if (!raw) return;
      var p;
      try { p = JSON.parse(raw); } catch (e) { return; }
      register(p);
      var list = card.querySelector('.bi-card__chips');
      if (list && !list.children.length) {
        list.innerHTML = chips(p).map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('');
      }
      var cb = card.querySelector('[data-bi-compare]');
      if (cb) cb.checked = inCompare(p.h);
    });
  }

  /* ---------- Add to basket + service add-ons ---------- */
  var dialog;
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'bi-dialog';
    dialog.setAttribute('aria-labelledby', 'BiSvcTitle');
    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    return dialog;
  }

  function addToCart(items, onError) {
    var body = {
      items: items,
      sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Could not add to basket');
        if (dialog && dialog.open) dialog.close();
        document.documentElement.dispatchEvent(new CustomEvent('bi:cart-updated', { detail: data, bubbles: true }));
        var cn = document.querySelector('cart-notification');
        if (cn && typeof cn.renderContents === 'function' && data.sections && data.items && data.items.length) {
          try {
            cn.renderContents(Object.assign({}, data, { key: data.items[0].key }));
            return data;
          } catch (e) { /* fall through to cart page */ }
        }
        window.location.href = ROOT + 'cart';
        return data;
      })
      .catch(function (err) { if (onError) onError(err); });
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    btn.disabled = busy;
    btn.classList.toggle('is-busy', busy);
    btn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function startAdd(p, btn) {
    setBusy(btn, true);
    fetch(ROOT + 'products/' + encodeURIComponent(p.h) + '?view=bi-services')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var items = Array.prototype.slice.call(doc.querySelectorAll('.service-addon-item')).map(function (el) {
          var cb = el.querySelector('.service-addon-item__checkbox');
          if (!cb) return null;
          var desc = el.querySelector('.service-addon-item__desc');
          return {
            id: cb.getAttribute('data-variant-id'),
            price: parseInt(cb.getAttribute('data-price'), 10) || 0,
            title: cb.getAttribute('data-title') || '',
            name: (el.querySelector('.service-addon-item__title') || {}).textContent || cb.getAttribute('data-title'),
            desc: desc ? desc.textContent.trim() : '',
            bundle: cb.getAttribute('data-is-bundle') === 'true'
          };
        }).filter(Boolean);
        if (!items.length) {
          return addToCart([{ id: p.vid, quantity: 1 }], function (err) {
            alertError(btn, err);
          }).then(function () { setBusy(btn, false); });
        }
        var subs = doc.querySelectorAll('.service-addons__subheading');
        var notice = subs.length > 1 ? subs[1].textContent.trim() : '';
        var cond = doc.querySelector('.service-addons__conditions-content');
        openServices(p, items, notice, cond ? cond.innerHTML : '', btn);
        setBusy(btn, false);
      });
  }

  function alertError(btn, err) {
    setBusy(btn, false);
    var msg = (err && err.message) || 'Sorry, something went wrong adding this to your basket.';
    toast(msg);
  }

  function openServices(p, items, notice, conditionsHTML, opener) {
    var d = ensureDialog();
    var CLOSE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
    d.innerHTML =
      '<div class="bi-dialog__inner">' +
      '<div class="bi-dialog__head"><h2 id="BiSvcTitle" class="bi-dialog__title">Add fitting services?</h2>' +
      '<button type="button" class="bi-dialog__close" data-bi-close aria-label="Close">' + CLOSE + '</button></div>' +
      '<div class="bi-dialog__product">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="96" height="96">' : '') +
      '<div><p class="bi-dialog__brand">' + esc(p.v) + '</p><p class="bi-dialog__name">' + esc(p.t) + '</p><p class="bi-dialog__price">' + fmt(p.p) + '</p></div></div>' +
      '<fieldset class="bi-svc"><legend class="bi-svc__legend">Let our team fit it for you</legend>' +
      items.map(function (it, i) {
        return '<label class="bi-svc__item"><input type="checkbox" data-i="' + i + '"' + (it.bundle ? ' data-bundle="1"' : '') + '>' +
          '<span class="bi-svc__text"><span class="bi-svc__name">' + esc(it.name) + '</span>' +
          (it.desc ? '<span class="bi-svc__desc">' + esc(it.desc) + '</span>' : '') + '</span>' +
          '<span class="bi-svc__price">+' + fmt(it.price) + '</span></label>';
      }).join('') +
      '</fieldset>' +
      (notice ? '<p class="bi-dialog__note">' + esc(notice) + '</p>' : '') +
      (conditionsHTML ? '<details class="bi-svc__conditions"><summary>Service conditions</summary><div>' + conditionsHTML + '</div></details>' : '') +
      '<div class="bi-dialog__total"><span>Total before delivery</span><strong data-bi-total>' + fmt(p.p) + '</strong></div>' +
      '<p class="bi-dialog__error" role="alert" hidden></p>' +
      '<div class="bi-dialog__actions"><button type="button" class="bi-btn bi-btn--primary" data-bi-confirm>Add to basket</button>' +
      '<a class="bi-btn bi-btn--secondary" href="' + esc(p.u) + '">View product</a></div>' +
      '</div>';

    var boxes = Array.prototype.slice.call(d.querySelectorAll('.bi-svc input'));
    var bundles = boxes.filter(function (b) { return b.hasAttribute('data-bundle'); });
    var singles = boxes.filter(function (b) { return !b.hasAttribute('data-bundle'); });
    function update(changed) {
      // Same rules as service-addons.js: a bundle replaces the individual services
      if (changed && changed.hasAttribute('data-bundle')) {
        singles.forEach(function (b) { if (changed.checked) b.checked = false; b.disabled = changed.checked; });
      } else if (changed) {
        var any = singles.some(function (b) { return b.checked; });
        bundles.forEach(function (b) { b.disabled = any; if (any) b.checked = false; });
      }
      var total = p.p;
      boxes.forEach(function (b) { if (b.checked) total += items[+b.getAttribute('data-i')].price; });
      d.querySelector('[data-bi-total]').textContent = fmt(total);
      boxes.forEach(function (b) { b.closest('.bi-svc__item').classList.toggle('is-checked', b.checked); });
    }
    boxes.forEach(function (b) { b.addEventListener('change', function () { update(b); }); });
    d.querySelector('[data-bi-close]').addEventListener('click', function () { d.close(); });
    var confirm = d.querySelector('[data-bi-confirm]');
    confirm.addEventListener('click', function () {
      var chosen = boxes.filter(function (b) { return b.checked; }).map(function (b) { return items[+b.getAttribute('data-i')]; });
      var list;
      if (chosen.length) {
        var bundleId = 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
        list = [{ id: p.vid, quantity: 1, properties: { _bundle_id: bundleId } }].concat(chosen.map(function (it) {
          return { id: it.id, quantity: 1, properties: { _bundle_id: bundleId, _service_for: p.t, _service_name: it.title } };
        }));
      } else {
        list = [{ id: p.vid, quantity: 1 }];
      }
      setBusy(confirm, true);
      confirm.textContent = 'Adding…';
      addToCart(list, function (err) {
        setBusy(confirm, false);
        confirm.textContent = 'Add to basket';
        var e = d.querySelector('.bi-dialog__error');
        e.hidden = false;
        e.textContent = (err && err.message) || 'Sorry, something went wrong. Please try again or call 01937 585646.';
      });
    });
    d.addEventListener('close', function () { if (opener && document.contains(opener)) opener.focus(); }, { once: true });
    d.showModal();
    var first = d.querySelector('.bi-svc input');
    if (first) first.focus();
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bi-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3500);
  }

  /* ---------- Compare ---------- */
  var CKEY = 'bi-compare-v1';
  var MAX = 4;
  var compare = [];
  try { compare = JSON.parse(localStorage.getItem(CKEY)) || []; } catch (e) { compare = []; }
  function saveCompare() { try { localStorage.setItem(CKEY, JSON.stringify(compare)); } catch (e) { /* storage unavailable */ } }
  function inCompare(h) { return compare.some(function (c) { return c.h === h; }); }
  function slim(p) {
    return { h: p.h, u: p.u, t: p.t, v: p.v, ty: p.ty, tg: p.tg, p: p.p, c: p.c, a: p.a, vid: p.vid, vc: p.vc, img: p.img, s: p.s };
  }
  function setCompare(p, on) {
    if (on && !inCompare(p.h)) {
      if (compare.length >= MAX) {
        toast('You can compare up to ' + MAX + ' products. Remove one to add another.');
        syncCompareBoxes();
        return;
      }
      compare.push(slim(p));
    } else if (!on) {
      compare = compare.filter(function (c) { return c.h !== p.h; });
    }
    saveCompare();
    syncCompareBoxes();
    renderTray();
  }
  function syncCompareBoxes() {
    document.querySelectorAll('.bi-card [data-bi-compare]').forEach(function (cb) {
      var card = cb.closest('[data-handle]');
      if (card) cb.checked = inCompare(card.getAttribute('data-handle'));
    });
  }

  var tray;
  function renderTray() {
    if (!tray) {
      tray = document.createElement('div');
      tray.className = 'bi-ctray';
      tray.setAttribute('role', 'region');
      tray.setAttribute('aria-label', 'Compare products');
      document.body.appendChild(tray);
      tray.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-bi-remove]');
        if (rm) {
          var h = rm.getAttribute('data-bi-remove');
          compare = compare.filter(function (c) { return c.h !== h; });
          saveCompare(); syncCompareBoxes(); renderTray();
          return;
        }
        if (e.target.closest('[data-bi-clear]')) { compare = []; saveCompare(); syncCompareBoxes(); renderTray(); return; }
        if (e.target.closest('[data-bi-open-compare]')) openCompare();
      });
    }
    document.body.classList.toggle('bi-has-ctray', compare.length > 0);
    if (!compare.length) { tray.hidden = true; tray.innerHTML = ''; return; }
    tray.hidden = false;
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var c = compare[i];
      slots += c
        ? '<li class="bi-ctray__item">' + (c.img ? '<img src="' + esc(c.img) + '" alt="" width="48" height="48">' : '') +
          '<span class="bi-ctray__name">' + esc(c.t) + '</span>' +
          '<button type="button" class="bi-ctray__remove" data-bi-remove="' + esc(c.h) + '" aria-label="Remove ' + esc(c.t) + ' from compare">×</button></li>'
        : '<li class="bi-ctray__item bi-ctray__item--empty" aria-hidden="true">Add a product</li>';
    }
    tray.innerHTML =
      '<div class="bi-ctray__inner page-width">' +
      '<ul class="bi-ctray__list" role="list">' + slots + '</ul>' +
      '<div class="bi-ctray__actions">' +
      '<button type="button" class="bi-btn bi-btn--primary" data-bi-open-compare' + (compare.length < 2 ? ' disabled' : '') + '>Compare (' + compare.length + ')</button>' +
      '<button type="button" class="bi-ctray__clear" data-bi-clear>Clear all</button>' +
      '</div></div>';
  }

  var cdialog;
  function openCompare() {
    if (compare.length < 2) return;
    if (!cdialog) {
      cdialog = document.createElement('dialog');
      cdialog.className = 'bi-dialog bi-dialog--compare';
      cdialog.setAttribute('aria-labelledby', 'BiCmpTitle');
      document.body.appendChild(cdialog);
      cdialog.addEventListener('click', function (e) { if (e.target === cdialog) cdialog.close(); });
    }
    var items = compare.map(function (c) { var p = REG[c.h] || register(c); return p; });
    var fam = family(items[0]);
    var keyRows = (GROUPS[fam] || []).concat(['energy', 'colour']).filter(function (k, i, a) { return a.indexOf(k) === i && k !== 'feat'; });
    var rows = [];
    rows.push(['Price', items.map(function (p) { return p.p > 0 ? fmt(p.p) : 'Call for price'; })]);
    rows.push(['Brand', items.map(function (p) { return p.v || '–'; })]);
    keyRows.forEach(function (k) {
      var vals = items.map(function (p) { var v = attr(p, k); return v == null ? '–' : String(v); });
      if (vals.some(function (v) { return v !== '–'; })) rows.push([EX[k].label, vals]);
    });
    if (FEATS[fam]) {
      FEATS[fam].forEach(function (f) {
        rows.push([f[0], items.map(function (p) { return f[1](p) ? 'Yes' : 'No'; })]);
      });
    }
    // Full spec list (union of description labels, first product's order first)
    var seen = {};
    var specRows = [];
    items.forEach(function (p) {
      specMap(p)._order.forEach(function (pair) {
        if (seen[pair[1]]) return;
        seen[pair[1]] = 1;
        specRows.push([pair[0], items.map(function (q) { return specMap(q)[pair[1]] || '–'; })]);
      });
    });
    var CLOSE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
    function rowHTML(r) {
      var same = r[1].every(function (v) { return v === r[1][0]; });
      return '<tr' + (same ? ' data-same="1"' : '') + '><th scope="row">' + esc(r[0]) + '</th>' + r[1].map(function (v) { return '<td>' + esc(v) + '</td>'; }).join('') + '</tr>';
    }
    cdialog.innerHTML =
      '<div class="bi-dialog__inner">' +
      '<div class="bi-dialog__head"><h2 id="BiCmpTitle" class="bi-dialog__title">Compare products</h2>' +
      '<button type="button" class="bi-dialog__close" data-bi-close aria-label="Close">' + CLOSE + '</button></div>' +
      '<label class="bi-cmp__diff"><input type="checkbox" data-bi-diff> Show differences only</label>' +
      '<div class="bi-cmp__scroll"><table class="bi-cmp"><thead><tr><td></td>' +
      items.map(function (p) {
        return '<th scope="col"><div class="bi-cmp__head">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="140" height="140">' : '') +
          '<a href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
          '<div class="bi-cmp__actions" data-handle="' + esc(p.h) + '">' +
          (p.p > 0 && p.a && p.vc <= 1 ? '<button type="button" class="bi-btn bi-btn--primary" data-bi-add>Add to basket</button>' : '<a class="bi-btn bi-btn--secondary" href="' + esc(p.u) + '">View product</a>') +
          '<button type="button" class="bi-cmp__remove" data-bi-cmp-remove="' + esc(p.h) + '">Remove</button></div></div></th>';
      }).join('') + '</tr></thead><tbody>' +
      rows.map(rowHTML).join('') +
      (specRows.length ? '<tr class="bi-cmp__section"><th scope="rowgroup" colspan="' + (items.length + 1) + '">Full specification</th></tr>' + specRows.map(rowHTML).join('') : '') +
      '</tbody></table></div></div>';
    cdialog.querySelector('[data-bi-close]').addEventListener('click', function () { cdialog.close(); });
    cdialog.querySelector('[data-bi-diff]').addEventListener('change', function (e) {
      cdialog.classList.toggle('bi-cmp--diff', e.target.checked);
    });
    cdialog.querySelectorAll('[data-bi-cmp-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = b.getAttribute('data-bi-cmp-remove');
        compare = compare.filter(function (c) { return c.h !== h; });
        saveCompare(); syncCompareBoxes(); renderTray();
        if (compare.length < 2) cdialog.close(); else openCompare();
      });
    });
    if (!cdialog.open) cdialog.showModal();
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bi-add]');
    if (!btn) return;
    var p = productFor(btn);
    if (!p) return;
    e.preventDefault();
    if (cdialog && cdialog.open) cdialog.close();
    startAdd(p, btn);
  });
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-bi-compare]');
    if (!cb) return;
    var p = productFor(cb);
    if (p) setCompare(p, cb.checked);
  });

  var pending;
  function scan() { clearTimeout(pending); pending = setTimeout(function () { initCards(document); }, 50); }
  function boot() {
    initCards(document);
    renderTray();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.BICards = {
    fmt: fmt, esc: esc, family: family, attr: attr, values: values, chips: chips,
    cardHTML: cardHTML, register: register, initCards: initCards,
    EX: EX, GROUPS: GROUPS, COMMON: COMMON, setPriceBuckets: setPriceBuckets, priceOrder: priceOrder,
    syncCompare: syncCompareBoxes
  };
  document.dispatchEvent(new CustomEvent('bi:cards-ready'));
})();
